"use client";

import { useEffect } from "react";
import { useStore } from "@/hooks/use-store";
import { UtmParams } from "@/store/user-store";
import { getGA4SessionId, getGA4ClientId } from "@/utils/ga4";

export function UTMTracker() {
  const { user } = useStore();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const params = new URLSearchParams(window.location.search);

    const waitForGA = () =>
      new Promise<{ gaClientId: string | null; gaSessionId: string | null }>((resolve) => {
        const start = Date.now();

        const interval = setInterval(() => {
          const gaClientId = getGA4ClientId();
          const gaSessionId = getGA4SessionId();

          if (gaClientId && gaSessionId) {
            clearInterval(interval);
            resolve({ gaClientId, gaSessionId });
            return;
          }

          if (Date.now() - start >= 15000) {
            clearInterval(interval);
            resolve({ gaClientId: null, gaSessionId: null });
          }
        }, 250);
      });

    const run = async () => {
      try {
        const { gaClientId, gaSessionId } = await waitForGA();

        const utmParams: UtmParams = {
          utm_source: params.get("utm_source"),
          utm_medium: params.get("utm_medium"),
          utm_campaign: params.get("utm_campaign"),
          utm_term: params.get("utm_term"),
          utm_content: params.get("utm_content"),
          utm_id: params.get("utm_id"),
          utm_binom_id: params.get("utm_binom_id"),
          ga_client_id: gaClientId,
          ga_session_id: gaSessionId,
        };

        user.setUtmParams(utmParams);
      } catch {
        // ignore
      }
    };

    run();
  }, []);

  return null;
}
